import React from 'react';
import { Helmet } from 'react-helmet';
import { Button } from '@components';
import { useNavigate, useParams } from 'react-router-dom';
import { Documentos } from './Documentos';
import { ListaFornecedores } from './ListaFornecedores';

const opcoesTransparencia = [
  {
    id: 'atasConselhoDeliberativo',
    nome: 'Atas do Conselho Deliberativo',
    texto:
      'O Conselho Deliberativo é o órgão de deliberação e orientação superior da Forluz. Selecione o período e tenha acesso às atas das reuniões realizadas.',
  },
  {
    id: 'atasConselhoFiscal',
    nome: 'Atas do Conselho Fiscal',
    texto:
      'O Conselho Fiscal é o órgão de fiscalização e controle interno da Entidade. Selecione o período e tenha acesso às atas das reuniões realizadas.',
  },
  {
    id: 'alteracoesRegulamentares',
    nome: 'Alterações Regulamentares',
    texto:
      'A Resolução CNPC nº 32 determina que as Entidades Fechadas de Previdência Complementar disponibilizem as propostas de mudanças no Regulamento em ambiente restrito aos participantes ativos e assistidos. Desta forma, selecione o período desejado para consultar os documentos.',
  },
  {
    id: 'alteracoesEstatuarias',
    nome: 'Alterações Estatuárias',
    texto:
      'A Resolução CNPC nº 32 determina que as Entidades Fechadas de Previdência Complementar disponibilizem as propostas de mudanças no Estatuto em ambiente restrito aos participantes ativos e assistidos. Desta forma, selecione o período desejado para consultar os documentos.',
  },
  {
    id: 'participacoesAssembleias',
    nome: 'Participações em Assembleias',
    texto:
      'A Resolução CNPC nº 32 determina que as Entidades Fechadas de Previdência Complementar disponibilizem os registros das assembleias que a Fundação participou em ambiente restrito aos participantes ativos e assistidos. Desta forma, selecione o período desejado para consultar as informações.',
  },
  {
    id: 'fornecedores',
    nome: 'Fornecedores',
    texto:
      'A Resolução CNPC nº 32 determina que as Entidades Fechadas de Previdência Complementar disponibilizem informações sobre os fornecedores parceiros em ambiente restrito aos participantes ativos e assistidos. Desta forma, confira a razão social e CNPJ de cada um deles.',
  },
];

export const TransparenciaPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const tipoTransparencia = opcoesTransparencia.find((item) => item.id === id);

  return (
    <>
      <Helmet>
        <title>Forluz - Transparência</title>
      </Helmet>
      <h1 className="page-title mb-3">
        <strong>{tipoTransparencia.nome}</strong>&nbsp;
      </h1>
      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      {tipoTransparencia.id === 'fornecedores' ? (
        <ListaFornecedores />
      ) : (
        <Documentos
          idDocumento={tipoTransparencia.id}
          texto={tipoTransparencia.texto}
        />
      )}
    </>
  );
};
